import HomeBanner from "../images/feature-banner.png";
import ReactDOM from "react-dom";
import React, { Component } from "react";
import Form from 'react-bootstrap/Form';
import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";

export default function FAQ() {
  const [faqListFirst, setFaqListFirst] = useState([]);
  const [faqListSecond, setFaqListSecond] = useState([]);

  useEffect(()=>{
    getTermsAndCondition()
  }, [])

  const getTermsAndCondition = async() => {
    await axios
      .get(process.env.REACT_APP_API_KEY + "api/faq-list/"+localStorage.getItem("selectLang"),
      {
        headers: {
        "Content-type": "Application/json"
        }   
      }).then(function (response) {  
        
        console.log("response.data =>", response.data.data);
        setFaqListFirst(response.data.data.listFirst);
        setFaqListSecond(response.data.data.listSecond);

      }).catch(function (error) {        
        console.log("error =>", error);
      });

  }
  
  return (
    <>
    <div className="TC-banner">
      <img src={HomeBanner} alt="" />
    </div>
    <div className="FAQ-container">
        <div className="FAQ-box">
            <h2>Frequently Asked Question</h2>
            <p>Have a question? We are here to help.</p>
            <div className="QnA-box">
            <section class="faq-section">
  <div class="container">
    <div class="row">
      <div class="col-md-6 ">
      <div class="faq" id="accordion">
      { faqListFirst.map((value, index) => (
          <div class="card" key={index}>
            <div class="card-header" id={`faqHeading-${value.id}`}>
              <div class="mb-0">
                <h5 class="faq-title" data-toggle="collapse" data-target={`#faqCollapse-${value.id}`} data-aria-expanded="true" data-aria-controls={`faqCollapse-${value.id}`}>
                  <span class="badge">1</span>{value.question}
                </h5>
              </div>
            </div>
            <div id={`faqCollapse-${value.id}`} class="collapse" aria-labelledby={`faqHeading-${value.id}`} data-parent="#accordion">
              <div class="card-body">
                <p>{value.answere}</p>
              </div>
            </div>
          </div>
      ))}
        </div>
        {/* <div class="faq-title text-center pb-3">
          <h2>FAQ</h2>
        </div> */}
      </div>
      <div class="col-md-6 ">
      <div class="faq" id="accordion2">
      { faqListSecond.map((value, index) => (
          <div class="card" key={index}>
            <div class="card-header" id={`faqHeading-${value.id}`}>
              <div class="mb-0">
                <h5 class="faq-title" data-toggle="collapse" data-target={`#faqCollapse-${value.id}`} data-aria-expanded="true" data-aria-controls={`faqCollapse-${value.id}`}>
                  <span class="badge">1</span>{value.question}
                </h5>
              </div>
            </div>
            <div id={`faqCollapse-${value.id}`} class="collapse" aria-labelledby={`faqHeading-${value.id}`} data-parent="#accordion2">
              <div class="card-body">
                <p>{value.answere}</p>
              </div>
            </div>
          </div>
      ))}
        </div>
      </div>
    </div>
  </div>
</section>
            </div>
        </div>
    </div>
    </>
  );
}

